/** Notes and rendered documents share the native client's HTTPS-only policy. */
export function isSafeMarkdownUrl(value: string): boolean {
  try { return new URL(value).protocol === 'https:'; }
  catch { return false; }
}
